import { render, staticRenderFns } from "./giftdataviewing.vue?vue&type=template&id=690dfc19&scoped=true&"
import script from "./giftdataviewing.vue?vue&type=script&lang=js&"
export * from "./giftdataviewing.vue?vue&type=script&lang=js&"
import style0 from "./giftdataviewing.vue?vue&type=style&index=0&id=690dfc19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690dfc19",
  null
  
)

export default component.exports